import { useProductStore } from '../../ProductProvider';
import ProductNav from '../../common/ProductNav';
import './index.scss';
import EfScrollAni from '@/efscrollani';
import BannerA from './components/BannerA';
import C from './components/C';
import E from './components/E';
import F from './components/F';
import G from './components/G';
import H from './components/H';
import I from './components/I';
// import J from './components/J';
import TC from './components/TC';
import EarlyBird_US from './components/EarlyBird_US';
import M from './components/M';
import N from './components/N';
import N_JP from './components/N_JP';
import NavPage from './components/NavPage';
import TabImgs from './components/TabImgs';
import TabSwiper from './components/TabSwiper';
import EarlyBirdJP from './components/EarlyBird_JP';
import EarlyBird from './components/EarlyBird';
import { IPageStatus } from '../../config/IPageStatus';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { generalKey } from '../../config/pageConfig';
import { useRouter } from 'next/router';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();
    const { gloproductlist } = useGlobal();
    const { locale = 'us' } = useRouter();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'nl'].includes(locale);
    const IS_US = ['us', 'ca'].includes(locale);
    return (
        <div className="page-product">
            <ProductNav activeTab={'Product'} buyLink={productMsg.buyLink} />
            <BannerA></BannerA>
            {pageStatus === IPageStatus.statusA && locale === 'jp' && <EarlyBirdJP endTime={new Date('2025/07/06 23:00:00 GMT+8').getTime()} />}
            {IS_EU && pageStatus !== IPageStatus.statusC && <EarlyBird endTime={new Date('2025/09/01 15:00:00 GMT+8').getTime()} />}
            {IS_US && <EarlyBird_US endTime={new Date('2025/09/08 15:00:00 GMT+8').getTime()} />}
            <C></C>
            <TabImgs></TabImgs>
            <E></E>
            {locale === 'jp' && <NavPage></NavPage>}
            <div className="page-section-bg">
                <F></F>
                <G></G>
                <H></H>
                <I></I>
                <TabSwiper></TabSwiper>
            </div>
            {/* <K></K>
            <L></L> */}
            <M></M>
            {locale !== 'jp' && <N></N>}
            {locale === 'jp' && <N_JP></N_JP>}
            {IS_EU && <TC></TC>}
        </div>
    );
}
